import { render, staticRenderFns } from "./SeeIdfa.vue?vue&type=template&id=bbd20272&"
import script from "./SeeIdfa.vue?vue&type=script&lang=js&"
export * from "./SeeIdfa.vue?vue&type=script&lang=js&"
import style0 from "./SeeIdfa.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbd20272')) {
      api.createRecord('bbd20272', component.options)
    } else {
      api.reload('bbd20272', component.options)
    }
    module.hot.accept("./SeeIdfa.vue?vue&type=template&id=bbd20272&", function () {
      api.rerender('bbd20272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/SubSys/SeeIdfa.vue"
export default component.exports